import { useEffect } from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';
import { StopIngestionRequest } from 'aws-sdk/clients/appfabric';

// Define the capsule interface for TypeScript
interface Capsule {
  capsuleID: number;
  title: string;
  description: string;
  message: string;
  images: {
    image: string;
    favourites?: string[];
    comments: {
      user: string;
      comment: string;
      timestamp: string;
    }[];
    owner: string;
    timestamp: string;
  }[];
  unlock: string;
  owner: string;
  access: string[];
  theme: string;
  print: boolean;
}

// Updated fetchCapsules function to use the API route
export const fetchCapsules = async (user: string): Promise<Capsule[]> => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/capsules/${user}`; // Replace with your actual API Gateway URL
  const { tokens } = await fetchAuthSession(); 
  const authToken = tokens?.accessToken?.toString(); 

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': authToken!,
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching capsules: ${response.statusText}`);
    }

    const capsules: Capsule[] = await response.json(); // Assuming the response is an array of capsules
    return capsules;
  } catch (error) {
    console.error(error);
    return []; // Return an empty array on error
  }
};

export const fetchCapsule = async (user: string, capsuleID: string): Promise<Capsule[]> => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/capsules/${user}?capsuleID=${capsuleID}`; // Replace with your actual API Gateway URL
  const { tokens } = await fetchAuthSession(); 
  const authToken = tokens?.accessToken?.toString(); 

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': authToken!,
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching capsules: ${response.statusText}`);
    }

    const capsules: Capsule[] = await response.json(); // Assuming the response is an array of capsules
    return capsules;
  } catch (error) {
    console.error(error);
    return []; // Return an empty array on error
  }
};

export const fetchOwnedCapsules = async (user: string): Promise<Capsule[]> => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/capsules/${user}?owned=true`; // Replace with your actual API Gateway URL
  const { tokens } = await fetchAuthSession(); 
  const authToken = tokens?.accessToken?.toString(); 

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': authToken!,
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching capsules: ${response.statusText}`);
    }

    const capsules: Capsule[] = await response.json(); // Assuming the response is an array of capsules
    return capsules;
  } catch (error) {
    console.error(error);
    return []; // Return an empty array on error
  }
};


export const fetchLockedCapsules = async (user: string): Promise<Capsule[]> => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/capsules/${user}?locked=true`; // Replace with your actual API Gateway URL
  const { tokens } = await fetchAuthSession(); 
  const authToken = tokens?.accessToken?.toString(); 

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': authToken!,
      }
    });

    if (!response.ok) {
      throw new Error(`Error fetching capsules: ${response.statusText}`);
    }

    const capsules: Capsule[] = await response.json(); // Assuming the response is an array of capsules
    return capsules;
  } catch (error) {
    console.error(error);
    return []; // Return an empty array on error
  }
};